import { render, staticRenderFns } from "./CollapseGroupedNotifications.vue?vue&type=template&id=b159c2d0&"
import script from "./CollapseGroupedNotifications.vue?vue&type=script&lang=js&"
export * from "./CollapseGroupedNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports